import React from 'react';
import { useSelector } from 'react-redux';
import style from './index.style';
import { useRouter } from 'next/router';

export default function DescriptionSeoCatalogo() {
  const router = useRouter();
  const { brand, category, subcategory, attributes } = router.query;

  const _banners =
    useSelector((state) => state.setting)?.find(
      (setting) => setting.type === 'TimedProductsBanner'
    )?.body?.banners || [];

  const banners = Object.entries(_banners)
    ?.map((banner) => banner?.[1])
    ?.filter((banner) => {
      const brandBanner = banner?.brand?.trim()?.toUpperCase() || undefined;
      const categoryBanner =
        banner?.category?.trim()?.toUpperCase() || undefined;
      const subcategoryBanner =
        banner?.subcategory?.trim()?.toUpperCase() || undefined;
      const canaleBanner = banner?.canale?.trim()?.toUpperCase() || undefined;
      const seoDescription = banner?.seoDescription?.['it_IT'] || undefined;

      return (
        banner?.status === true &&
        brandBanner === brand?.toUpperCase() &&
        categoryBanner === category?.toUpperCase() &&
        subcategoryBanner === subcategory?.toUpperCase() &&
        canaleBanner === attributes?.split('-')[1]?.toUpperCase() &&
        seoDescription
      );
    });

  if (banners?.length === 0) return null;

  return (
    <div>
      <div
        className={'description-container'}
        dangerouslySetInnerHTML={{
          __html: banners[0]?.seoDescription?.['it_IT'] || '',
        }}
      />
      <style jsx>{style}</style>
    </div>
  );
}
